<template>
	<div class="mdc-snackbar notice">
		<div class="mdc-snackbar__surface">
			<div class="mdc-snackbar__label"
				role="status"
				aria-live="polite"
				area-atomic="false"
				v-html="options.message"
			>
			</div>

			<div class="mdc-snackbar__actions" aria-atomic="true">
				<button type="button" class="mdc-button mdc-snackbar__action" @click="options.action()" v-if="options.action && options.actionButtonText">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label">{{ options.actionButtonText }}</span>
				</button>
				<button type="button" class="mdc-icon-button mdc-snackbar__dismiss material-icons" title="Dismiss">close</button>
			</div>
		</div>
	</div>
</template>

<script>
// Dependencies
import { MDCSnackbar } from '@material/snackbar'

// Component
export default {
	name: 'noticePlugin',
	data: () => ({
		snackbar: null,
		defaults: {
			actionButtonText: '',
			action: () => ({}),
			timeout: 5000,
		},
		options: {},
		queued: [],
		timer: null,
	}),
	mounted() {
		this.snackbar = new MDCSnackbar(this.$el)
		this.snackbar.listen(`MDCSnackbar:closed`, () => {
			this.queued.shift()
		})
	},
	methods: {
		close() {
			this.snackbar.close()
		},
	},
	watch: {
		queued(opt) {
			if (!opt.length) return

			const options = this.queued[0]
			this.options = Object.assign({}, this.defaults, options)
			this.snackbar.timeoutMs = this.options.timeout
			this.snackbar.open()
		},
	},
}
</script>

<style scoped lang="scss">
@use '@material/button';
@use '@material/snackbar/mdc-snackbar';
@use '@material/icon-button/mdc-icon-button';

.mdc-snackbar {

	&__action {
		// @include button.container-fill-color(modules.color_('secondary'));
		@include button.ink-color(modules.color_('primary'));
	}

	.mdc-icon-button {
		color: white;
	}
}
</style>
